import { Body, Button, Dialog, Spacer, useAlert } from '@spritz-finance/ui'
import styled from 'styled-components'
import { InnerLoading } from '../../../../components/InnerLoading'
import { useDeleteBankAccountMutation } from '../../../../graphql/generated/graphql'
import { BankAccount } from '../BankAccounts'

const RemoveAccountContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: opacity 0.2s ease-out;
`

type RemoveAccountDialogProps = {
    account: BankAccount | null
    onClose: () => void
}

export const RemoveAccountDialog: React.VFC<RemoveAccountDialogProps> = ({ onClose, account }) => {
    const alert = useAlert()

    const [removeAccount, { loading }] = useDeleteBankAccountMutation({
        variables: { accountId: account?.id || '' },
        onCompleted() {
            alert.success('Removed Bank Account')
            onClose()
        },
        refetchQueries: ['BankAccounts', 'BillsData'],
        awaitRefetchQueries: true,
    })

    const handleCloseDialog = () => {
        if (loading) return
        onClose()
    }

    const handleRemoveAccount = async () => {
        if (!account) return
        await removeAccount()
    }

    return (
        <Dialog open={!!account} onClose={handleCloseDialog}>
            <Dialog.Content minWidth={560}>
                <RemoveAccountContainer>
                    {loading && <InnerLoading />}
                    <Spacer height={16} />
                    <Body.SmBold size={18}>Remove bank account</Body.SmBold>
                    <Spacer height={16} />
                    <Body.Med size={14} style={{ textAlign: 'center' }}>
                        Are you sure you want to remove this bank account?
                    </Body.Med>
                    <Spacer height={32} />
                    <Button.CTA
                        onClick={handleRemoveAccount}
                        variant="secondary"
                        style={{ width: '110px' }}
                    >
                        Remove
                    </Button.CTA>
                </RemoveAccountContainer>
            </Dialog.Content>
        </Dialog>
    )
}
